import { ApiService } from '~/services/api/api'
import type { Artefact } from '~/types/Artefact'

export class FileUploadService {
  private readonly apiService = new ApiService()

  private static getFormDataFromFile(file: File) {
    const formData = new FormData()
    formData.append('file', file, file.name)
    return formData
  }

  private static getFormDataFromFiles(files: File[] | FileList) {
    const formData = new FormData()
    Array.from(files).forEach((file) => {
      formData.append('files', file, file.name)
    })
    return formData
  }

  async uploadFile(file: File) {
    const response = await this.apiService.post<Artefact, FormData>(
      '/uploads',
      FileUploadService.getFormDataFromFile(file),
      {
        useFallbackAuth: true,
      },
    )
    return response
  }

  async uploadFilesToEndpoint<ResponseT>(
    endpoint: string,
    files: File[] | FileList,
    additionalFormData?: Record<string, string>,
    options?: { useFallbackAuth?: boolean },
  ) {
    const formData = FileUploadService.getFormDataFromFiles(files)

    if (additionalFormData) {
      Object.entries(additionalFormData).forEach(([key, value]) => {
        formData.append(key, value)
      })
    }

    const response = await this.apiService.post<ResponseT, FormData>(
      endpoint,
      formData,
      {
        useFallbackAuth: options?.useFallbackAuth ?? false,
      },
    )
    return response
  }
}
